import styled from "styled-components";

import { Icon } from "@components/General/Icon";

import { Star as StarIcon } from "@ui/Assets/MyIcons";
import { Text } from "@ui/Atoms";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_12};

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    align-items: end;
  }
`;

export const Rating = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_4};
  flex-direction: column;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.spacing_12};
  }
`;

export const Stars = styled.div`
  display: flex;
  gap: 6px;
`;

export const Star = styled(StarIcon)`
  stroke: ${({ theme }) => theme.palette.yellow500};
  fill: ${({ theme }) => theme.palette.yellow500};
`;

export const AdaptiveIcon = styled(Icon).attrs({
  size: {
    default: "base_x4",
    smallTablet: "base_x6",
    smallDesktop: "base_x8",
  },
})``;

export const Score = styled(Text).attrs({
  $style: {
    default: "bold_40",
    smallTablet: "bold_56",
    smallDesktop: "bold_96",
  },
  $color: "white",
})``;

export const RatingAnotation = styled(Text).attrs({
  $style: {
    default: "regular_16",
    smallTablet: "regular_14",
    smallDesktop: "regular_16",
  },
  $color: "white",
})``;
